import { isEmpty } from 'lodash'
import { SIMPLE_EMAIL_REGEX } from '../../gateway/gateway'
import { getErrorMessages } from './constants'
import { isSessionValid } from '../session'
import { LoftRecord } from './record'
import { LoftServices } from '../../types/loft'

export const throwOnInvalidSession = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  if (
    !isSessionValid(state.session?.expiration_date || false, state.session?.access_token || false)
  ) {
    throw errorMessages.INVALID_SESSION
  }
}

export const throwOnInvalidAttendees = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const attendees = await state.getAsync('attendees')

  if (!attendees?.length) {
    throw errorMessages.INVALID_ATTENDEES
  }
}

export const throwOnInvalidRecurrence = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const recurrence = await state.getAsync('recurrence')

  if (!isEmpty(recurrence)) {
    throw errorMessages.INVALID_RECURRENCE
  }
}

export const throwOnInvalidRecipient = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  if (!SIMPLE_EMAIL_REGEX.test(state.emailAddress || '')) {
    throw errorMessages.RECIPIENT_INVALID
  }
}

export const throwOnInvalidPerson = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const person = await state.getAsync('recipient')
  if (person && (person.do_not_contact || person.do_not_email)) {
    throw errorMessages.RECIPIENT_DNC
  }
}

export const throwOnMissingCreatePersonPermission = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const person = await state.getAsync('recipient')
  if (person && !isEmpty(person)) return

  const me = await state.getAsync('me').catch(() => undefined)
  const permissionNames: string[] = me?.data?._private_fields?.permission_names || []
  if (!permissionNames.includes('create_people_when_lofting')) {
    throw errorMessages.NO_PERMISSION_CREATE_PERSON
  }
}

export const throwOnExcludedDomain = async (state: LoftRecord, services?: LoftServices) => {
  const errorMessages = getErrorMessages()
  const email = state.emailAddress || ''
  const domain = email.replace(/.*@/, '').toLowerCase()
  if (!domain || !services?.gateway?.publicTeamEmailSettings) return

  const excludedDomains: string[] = await services.gateway.publicTeamEmailSettings
    .getInternalDomains()
    .catch(() => [])

  const normalized = excludedDomains.map(d => (d || '').toLowerCase())
  if (normalized.includes(domain)) {
    throw errorMessages.RECIPIENT_INTERNAL_DOMAIN
  }
}
